import type { ClaudeAccount } from '@one-deployment/api'
import { Select } from '@/components/ui'
import { useClaudeAccounts } from './accounts'

const stateNote = (a: ClaudeAccount) => (a.state === 'limited' ? ' (at limit)' : a.state === 'invalid' ? ' (needs sign-in)' : '')

/**
 * Pick the Claude account a session or run uses. "" is the agent default.
 * With no accounts at all, nothing to pick: the project's own login is used.
 */
export function AccountPicker({ value, onChange, label = 'Claude account', disabled }: { value: string | null; onChange: (id: string | null) => void; label?: string; disabled?: boolean }) {
  const accounts = useClaudeAccounts().data?.accounts ?? []
  if (accounts.length === 0) return null
  const def = accounts.find((a) => a.isDefault)
  return (
    <Select value={value ?? ''} onChange={(e) => onChange(e.target.value || null)} aria-label={label} title={label} disabled={disabled} className="h-7 text-xs">
      <option value="">Default{def ? ` · ${def.label}` : ''}</option>
      {accounts.map((a) => <option key={a.id} value={a.id}>{a.label}{stateNote(a)}</option>)}
    </Select>
  )
}

/** An account's label, for showing which one a session ran on. */
export function useAccountLabel(id: string | null | undefined): string | null {
  const accounts = useClaudeAccounts().data?.accounts ?? []
  if (!id) return null
  return accounts.find((a) => a.id === id)?.label ?? 'removed account'
}
